import React from 'react';
import loadable from '@loadable/component';
import LoadingScreen from 'components/LoadingScreen';

const LoadablePrequalOfferPushApplication = loadable(
  () => import('./PrequalOfferPushApplication'),
  {
    fallback: <LoadingScreen />,
  },
);

export default LoadablePrequalOfferPushApplication;
